/* istanbul ignore next */
export const TableEditorId = 'TableEditor';
